<div class="page-filter-component">
    <div class="d-flex flex-row-reverse">
        <button mat-flat-button disableRipple class="filter-toggle" (click)="toggleFilter()"><span i18n="@@page-filter-form-filter-button-text">Filter</span><i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true" *ngIf="!filterOpen"></i><i class="ml-2 ms-Icon ms-Icon--ChevronUp" aria-hidden="true" *ngIf="filterOpen"></i></button>
    </div>
    <mat-expansion-panel [expanded]="filterOpen" class="filter-panel">
        <form [formGroup]="queryOptionsForm">
            <div class="row mb-4 align-items-end mt-4">
                <!-- Search text -->
                <div class="col">
                    <div class="row">
                        <mat-label class="col">
                            <span i18n="@@page-filter-form-search-heading"><b>Search:</b></span>
                        </mat-label>
                    </div>
                    <mat-form-field class="w-100">
                        <mat-label i18n="@@page-filter-form-search-input-label">Search text</mat-label>
                        <input matInput [formControl]="searchText">
                    </mat-form-field>
                </div>
                <!-- Date pickers -->
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3">
                    <div class="row">
                        <mat-form-field class="col-6">
                            <input matInput
                                   placeholder="Start date"
                                   autocomplete="off"
                                   formControlName="startDate"
                                   i18n-placeholder="@@page-filter-form-placeholder-startdate"
                                   [matDatepicker]="StartDatePicker">
                            <mat-datepicker-toggle matSuffix [for]="StartDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #StartDatePicker></mat-datepicker>
                            <mat-error *ngIf="queryOptionsForm.get('startDate').invalid"><span i18n="@@start-date-before-end">Start date must be before end date</span></mat-error>
                        </mat-form-field>
                        <mat-form-field class="col-6">
                            <input matInput
                                   placeholder="End date"
                                   autocomplete="off"
                                   formControlName="endDate"
                                   i18n-placeholder="@@page-filter-form-placeholder-enddate"
                                   [matDatepicker]="EndDatePicker">
                            <mat-datepicker-toggle matSuffix [for]="EndDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #EndDatePicker></mat-datepicker>
                            <mat-error *ngIf="queryOptionsForm.get('endDate').invalid"><span i18n="@@end-date-after-start-date">End date must be after start date</span></mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <!-- All news / Top news + editor options-->
                <div *ngIf="isNews || editorOptionsEnabled" class="col-auto mb-3">
                    <div class="row mb-3">
                        <mat-label class="col-auto">
                            <span i18n="@@page-filter-form-allnews-topnews-heading"><b>Show:</b></span>
                        </mat-label>
                    </div>
                    <div class="d-flex">
                        <mat-radio-group formControlName="topNewsOnlyOption" *ngIf="isNews" class="row mr-2">
                            <div class="col-auto">
                                <mat-radio-button [value]="0">
                                    <span i18n="@@page-filter-form-channel-matching-any">All news</span>
                                </mat-radio-button>
                            </div>
                            <div class="col-auto">
                                <mat-radio-button [value]="1">
                                    <span i18n="@@page-filter-form-channel-matching-all">Only top news</span>
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                        <div *ngIf="languageFilteringEnabled" class="mr-2 row">
                            <div class="col-auto">
                                <mat-checkbox formControlName="onlyInCurrentUserLanguages" i18n="@@page-filter-form-my-languages-only"><span>Only in my language(s)</span></mat-checkbox>
                            </div>
                        </div>
                        <div *ngIf="editorOptionsEnabled" class="row">
                            <div class="col-auto">
                                <mat-checkbox formControlName="onlyCurrentUserPages" i18n="@@page-filter-form-current-users-owned-or-edited"><span>Only owned or modified by me</span></mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-auto mb-3" [ngClass]="featureSettings.newsArchiveFilter ? 'page-filter-component-wp-option' : ''">
                    <div class="row mb-3">
                        <mat-label class="col-auto">
                            <span i18n="@@page-filter-form-allnews-topnews-heading"><b>Workplace:</b></span>
                        </mat-label>
                    </div>
                    <div class="d-flex">
                        <div *ngIf="editorOptionsEnabled" class="row">
                            <div class="col-auto">
                                <mat-checkbox formControlName="includeDrafts" i18n="@@page-filter-form-include-drafts">Include drafts</mat-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                      <div *ngIf="featureSettings.newsArchiveFilter" class="row">
                        <div class="col-auto mb-3">
                            <mat-checkbox formControlName="includeArchive" i18n="@@page-filter-form-archived-news">Only archived news</mat-checkbox>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </form>
        <!-- Channel filter form -->
        <form [formGroup]="channelFilterForm">
            <div class="row mb-2">
                <div class="col">
                    <mat-label>
                        <span i18n="@@page-filter-form-channel-filter-label"><b>Channel filter:</b></span>
                    </mat-label>
                </div>
            </div>
            <div class="row align-items-end">
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-chip-list #channelChipList>
                            <mat-chip *ngFor="let channel of selectedChannels" [value]="channel.Guid"
                                      [removable]="true" (removed)="handleRemoveSelectedChannel(channel)">
                                {{channel.Name}}
                                <mat-icon *ngIf="queryOptionsForm.valid" matChipRemove>cancel</mat-icon>
                            </mat-chip>
                            <input [matChipInputFor]="channelChipList"
                                   placeholder="Channels"
                                   i18n-placeholder="@@page-filter-form-placeholder-channels"
                                   (focus)="channelFocus()"
                                   [readonly]=true
                                   #trigger="cdkOverlayOrigin" cdkOverlayOrigin>
                        </mat-chip-list>
                    </mat-form-field>
                    <input matInput formControlName="selectedChannels" class="d-none" />
                    <ng-template cdk-connected-overlay
                                 cdkConnectedOverlayHasBackdrop
                                 cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                                 [cdkConnectedOverlayMinWidth]="_domTrigger?.width"
                                 [cdkConnectedOverlayMinHeight]="_domTrigger?.height * 2"
                                 [cdkConnectedOverlayOrigin]="trigger"
                                 [cdkConnectedOverlayOpen]="channelMenuOpen"
                                 (backdropClick)="channelMenuOpen=false"
                                 *ngIf="queryOptionsForm.valid">
                        <div class="mat-select-panel page-filter-component-container-expand-channel-list">
                            <app-channel-control [channels]="channels" (selectionChange)="handleSelectedChannelsChange($event)"></app-channel-control>
                        </div>
                    </ng-template>
                </div>
                <div class="col-auto">
                    <mat-radio-group formControlName="channelsMatchingOption" class="row mb-3">
                        <div class="col-auto">
                            <mat-radio-button [value]="0">
                                <span i18n="@@newscenter-filter-form-channel-matching-any">
                                    Match any selected channel
                                </span>
                            </mat-radio-button>
                        </div>
                        <div class="col-auto">
                            <mat-radio-button [value]="1">
                                <span i18n="@@newscenter-filter-form-channel-matching-all">
                                    Match all selected channels
                                </span>
                            </mat-radio-button>
                        </div>
                    </mat-radio-group>
                </div>
             </div>
        </form>
    </mat-expansion-panel>
</div>
